// Recipe Book section links (client, 30/09/2026): dietasocial.it/recipe/<section>
// opens Ricette on that section, as if its chip had been tapped. The section is
// named by its chip label (the CRM "Categoria" filters), so "Secondi di pesce"
// is secondi-di-pesce; a label renamed in the CRM simply stops matching and the
// link opens "Tutte".

export const RECIPE_SECTION_PARAM = "sezione";

// Lower-case words joined by hyphens, with at least one letter so a number
// stays a single-recipe link (/recipe/8772).
export const RECIPE_SECTION_SLUG_RE = /^(?=[a-z0-9-]*[a-z])[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const recipeSectionSlug = (label) =>
  String(label || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const recipeSectionInternalPath = (slug) =>
  `/ricette?${RECIPE_SECTION_PARAM}=${slug}`;

export const recipeSectionPublicUrl = (label) =>
  `https://dietasocial.it/recipe/${recipeSectionSlug(label)}`;

/** The chip ({ id, label }) a link names, or null ("Tutte" is never a match). */
export const findRecipeSection = (sections, slug) => {
  const wanted = String(slug || "").toLowerCase();
  if (!RECIPE_SECTION_SLUG_RE.test(wanted)) return null;
  return (
    (sections || []).find(
      (section) =>
        section?.id !== "all" && recipeSectionSlug(section?.label) === wanted,
    ) || null
  );
};
